// extracted by mini-css-extract-plugin
module.exports = {"chatItem":"ChatItem_chatItem__2BkCU","text":"ChatItem_text__3hYlu","isActive":"ChatItem_isActive__24FgT"};